module.exports = __webpack_public_path__ + "static/media/GA-2100BWP-2AER_OR02_wristshot.3fa86781.jpg";